export default (http, store, router) => {

  http.interceptors.request.use(
    function (config) {
      store.dispatch('setLoading', true);
      return config;
    },
    function (error) {
      store.dispatch('setLoading', false);
      return Promise.reject(error);
    }
  );

  http.interceptors.response.use(
    response => {
      store.dispatch('setLoading', false);
      return response;

    }, error => {

      const {
        response
      } = error;

      if (!error.response) {
        store.dispatch('setLoading', false);
        store.dispatch('showMessage', {
          type: 'danger',
          content: 'Ocorreu um erro interno no servidor. Tente novamente.'
        });
        return Promise.reject(error);
      }

      /**
       * If token is either expired, not provided or invalid
       * then redirect to login.
       */
      if (401 === response.status) {
        store.dispatch('showMessage', {
          type: 'danger',
          content: 'A sessão expirou. Efetue o login novamente.'
        });

        store.dispatch('auth/logout');

        router.push({
          name: 'auth.login'
        });
      }

      /**
       * Show error messages
       */
      if (response.data.message) {
        store.dispatch('showMessage', {
          type: 'danger',
          content: response.data.message
        });
      }

      store.dispatch('setLoading', false);

      return Promise.reject(error);
    });

}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors.js